module.exports = __webpack_public_path__ + "static/media/1.4733d23c.svg";